@if (operations === undefined) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading track operations...
</div>
}

@if (operations && !operations.length) {
<div class="loading-status">
	No operations with track data are available
</div>
}

@if (operations && operations.length > 0) {
<div class="row">
	<div class="col-lg-6">
		<div class="panel">
			<div class="heading">Operations</div>
			<div class="content">
				<div class="row">
					<label class="col-md-4 col-form-label">Before operation:</label>
					<div class="col-md-8">
						<select class="form-control form-control-sm" [(ngModel)]="opBefore" (ngModelChange)="updatePlot()"
							title="Only showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT + ' ' : '' }}operations with track data for rotor '{{rotor.rotorid}}'">
							@for (operation of operations; track operation) {
							<option [ngValue]="operation">
								{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
								runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}
							</option>
							}
						</select>
					</div>
				</div>
				<div class="row">
					<label class="col-md-4 col-form-label">After operation:</label>
					<div class="col-md-8">
						<select class="form-control form-control-sm" [(ngModel)]="opAfter" (ngModelChange)="updatePlot()"
							title="Only showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT + ' ' : '' }}operations with track data for rotor '{{rotor.rotorid}}'">
							@for (operation of operations; track operation) {
							<option [ngValue]="operation">
								{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
								runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}
							</option>
							}
						</select>
					</div>
				</div>
			</div>
		</div>
		@if (rotor && adjustments) {
		<div class="panel">
			<div class="heading">Adjustments</div>
			<div class="content">
				<table class="adjustments fat">
					@for (adjdef of rotor.adjdef; track adjdef; let i = $index) {
					<!-- Display heading for every "display group" -->
					@if (i === 0 || rotor.adjdef[i].displaygroup !== rotor.adjdef[i-1].displaygroup) {
					<tr>
						<th></th>
						@for (blade of ReorderBlades(rotor.blade); track blade) {
						<th>{{blade.name}}</th>
						}
					</tr>
					}
					<tr>
						<th>{{ adjdef.name }}</th>
						@for (blade of rotor.blade; track blade; let j = $index) {
						<td>
							<input type="number" step="any" class="form-control" [(ngModel)]="adjustments[i][j]">
						</td>
						}
					</tr>
					}
				</table>
			</div>
		</div>
		}
		@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
		<div class="row">
			<div class="col-4">
				Shaft Order
			</div>
			<div class="col-8">
				<div class="form-check form-check-inline">
					<label>
						<input [(ngModel)]="shaftOrder" type="radio" [value]="1" (ngModelChange)="updateBothPlots()"> 1/rev
					</label>
				</div>
				<div class="form-check form-check-inline">
					<label>
						<input [(ngModel)]="shaftOrder" type="radio" [value]="2" (ngModelChange)="updateBothPlots()"> 2/rev
					</label>
				</div>
			</div>
		</div>
		}
		<div class="row mt-3">
			<div class="col-lg-6">
				<app-action-button [action]="CalculateCoefficients" [context]="this" processing="Calculating..." complete="Complete">Calculate Coefficients</app-action-button>
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<div class="panel">
			<div class="heading">Blade track</div>
			<div class="content">
				<app-dvs-chart [options]="trackOptions" [height]="'400px'" [error]="errormessage"></app-dvs-chart>
				@if (trackOptions) {
				<div class="chart-legend">
					<span class="legend-item">
						<span class="swatch diamond"></span> Before Averages
					</span>
					<span class="legend-item">
						<span class="swatch square"></span> After Averages
					</span>
				</div>
				}
			</div>
		</div>
	</div>
</div>
}
@if (coefficientText) {
<div id="coefficient-results" class="panel">
	<div class="heading">Result</div>
	<div class="content">
		<textarea [(ngModel)]="coefficientText" class="form-control" style="min-height: 400px;" readonly></textarea>
	</div>
</div>
}
@if (operations && operations.length > 0) {
<div class="panel">
	<div class="heading">Track Split</div>
	<div class="content">
		<app-dvs-chart [options]="timelineOptions" loading="Loading track data" [height]="'300px'"></app-dvs-chart>
		@if (timelineOptions && adjustments && adjustments.length) {
		<div class="chart-legend">
			<span class="legend-item">
				<span class="swatch adjustment"></span> Adjustment
			</span>
		</div>
		}
	</div>
</div>
}